export default "__VITE_ASSET__KHIrv2Xl__"